import React, { useEffect, useContext, useState, useRef } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';

import Moment from 'moment'

import { Box, Button, Drawer, Dialog, Checkbox, TextField, Select, FormControl, InputLabel, MenuItem } from '@mui/material'

import { ReactComponent as XIcon } from '../../../../images/x-icon.svg'
import loadingGIF from '../../../../images/loadingGIF.gif'

import { PlusCircle as PlusCircleIcon } from 'react-feather';
import { XCircle as XCircleIcon } from 'react-feather';

import { v4 as uuidv4 } from 'uuid';
import APIS from "../../../../utils/APIS"

import { SocketContext } from "../../../../contexts/SocketContext"

Moment.locale('fr')

const DialogContent = ({ groupState, step, setStep, onClose, reloadResults }) => {

  const socket = useContext(SocketContext)

  useEffect(() => {
    //console.log(socket?.connected)
  }, [])

  useEffect(() => {
    const createSimuUpdateEvent = (data) => {
      if (data?.uuid === glbUUID) {
        let percent = (data?.nbrActSimu / data?.nbrTotSimulation)*100
        setGlbPercent( Math.round(percent * 100) / 100 )
      }
    }
    socket?.on("createSimuUpdate", createSimuUpdateEvent)
    return () => {
      socket?.off("createSimuUpdate", createSimuUpdateEvent)
    }
  }, [])

  const [glbUUID, setGlbUUID] = useState(uuidv4())

  /* step 0 */
  const [modulesChoose, setModulesChoose] = useState([])
  useEffect(() => {
    let newDates = []
    modulesChoose?.forEach((p) => {
      newDates.push({
        id : p.id,
        openDate : Moment(p.openDate, "YYYY-MM-DD"),
        closeDate : Moment(p.closeDate, "YYYY-MM-DD")
      })
    })
    setDates(newDates)
  }, [modulesChoose])

  /* step 1 */
  const [nbrUsers, setNbrUsers] = useState(groupState.maxSlot - groupState.nUsers)
  const [names, setNames] = useState("IA")
  const [emails, setEmails] = useState("IA")
  const [sexes, setSexes] = useState("random")
  const [ages, setAges] = useState("random18-30")
  const [postes, setPostes] = useState("IA")
  const [postesList, setPostesList] = useState(["poste"])

  /* step 2 */
  const [secteurs, setSecteurs] = useState([])
  const [annees, setAnnees] = useState([])
  const [diplomes, setDiplomes] = useState([])
  let disableStep2 = false
  if (groupState.icebreakerQuestions.secteurs === true && secteurs.length === 0) {
    disableStep2 = true
  }
  if (groupState.icebreakerQuestions.annees === true && annees.length === 0) {
    disableStep2 = true
  }
  if (groupState.icebreakerQuestions.diplome === true && diplomes.length === 0) {
    disableStep2 = true
  }

  /* step 3 */
  const [dates, setDates] = useState([])
  const [dateIsValid, setDateIsValid] = useState(false)

  useEffect(() => {
    let valid = true
    dates.forEach((d) => {
      try {
        let formation = modulesChoose.find((el) => el.id === d.id)
        let open = Moment(formation.openDate, "YYYY-MM-DD")
        let close = Moment(formation.closeDate, "YYYY-MM-DD")
        if(d.openDate.isValid() === true && d.closeDate.isValid() === true) {
          //date ok, on teste si c'est dans le délai d'ouverture de la formation
          if (d.openDate.isBetween(open, close, 'days', '[]') && d.closeDate.isBetween(open, close, 'days', '[]')) {
            //ok, on teste si les dates sont dans le bon ordre
            if (d.openDate.isSameOrBefore(d.closeDate, 'days')) {
              //ok
            } else {
              valid = false
            }
          } else {
            valid = false
          }
        } else {
          valid = false
        }
      } catch(e) {
        valid = false
      }
    })

    setDateIsValid(valid)

  }, [modulesChoose, dates])

  /* step 4 */
  const [isCreating, setIsCreating] = useState(false)
  const [glbPercent, setGlbPercent] = useState(0)

  return (
    <Box sx={{
      padding:"20px",
    }}>
      <Box sx={{display:"flex", justifyContent:"flex-end"}}>
        <XIcon width="20px" height="20px" onClick={onClose} style={{
          cursor:"pointer",
          color:"#4B5C7D"
        }}/>
      </Box>
      <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"15px"}}>
        <Box sx={{fontSize:"27px", fontWeight:"bold", textAlign:"center"}}>
          {step === 0 && "Simulation - Choix des modules"}
          {step === 1 && "Simulation - Choix des options"}
          {step === 2 && "Simulation - Choix des réponses IceBreaker"}
          {step === 3 && "Simulation - Choix des dates"}
          {step === 4 && "Simulation - Confirmation"}
        </Box>
      </Box>
      <Box sx={{padding:"0px 10px"}}>
        {step === 0 &&
          <>
            {groupState?.plan?.map((formation, index) => {
              return (
                <Box key={index} sx={{display:"flex", alignItems:"center", gap:"10px"}}>
                  <Checkbox checked={modulesChoose.find((el) => el.id === formation.id) !== undefined} onClick={() => {
                    let find = modulesChoose.find((el) => el.id === formation.id)
                    if (find) {
                      setModulesChoose(
                        modulesChoose.filter(el =>
                          el.id !== formation.id
                        )
                      );
                    } else {
                      setModulesChoose([
                        ...modulesChoose,
                        formation
                      ]);
                    }
                  }}/>
                  {formation.name} ({Moment(formation.openDate, "YYYY-MM-DD").format("DD/MM/YYYY")}) - ({Moment(formation.closeDate, "YYYY-MM-DD").format("DD/MM/YYYY")})
                </Box>
              )
            })}
          </>
        }
        {step === 1 &&
          <Box sx={{marginTop:"10px"}}>
            <Box sx={{display:"flex", alignItems:"center", gap:"10px"}}>
              Nombre d'utilisateurs&nbsp;: <TextField value={nbrUsers.toString()} size="small" sx={{height:"40px"}} onChange={(e) => {
                if (e.target.value === "") {
                  setNbrUsers(0)
                } else {
                  let int = parseInt(e.target.value)
                  let max = groupState.maxSlot - groupState.nUsers
                  if (int > max) {
                    int = max
                  }
                  setNbrUsers(int)
                }
              }}/>
            </Box>

            <Box sx={{display:"flex", alignItems:"center", gap:"10px", marginTop:"40px"}}>
              Noms / Prénoms&nbsp;:
              <FormControl size="small" sx={{height:"40px"}}>
                <Select value={names} onChange={(e) => {setNames(e.target.value)}} >
                  <MenuItem value="IA">Générés par IA</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{display:"flex", alignItems:"center", gap:"10px", marginTop:"15px"}}>
              Emails&nbsp;:
              <FormControl size="small" sx={{height:"40px"}}>
                <Select value={emails} onChange={(e) => {setEmails(e.target.value)}} >
                  <MenuItem value="IA">Générés par IA</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{display:"flex", alignItems:"center", gap:"10px", marginTop:"15px"}}>
              Sexes&nbsp;:
              <FormControl size="small" sx={{height:"40px"}}>
                <Select value={sexes} onChange={(e) => {setSexes(e.target.value)}} >
                  <MenuItem value="random">Aléatoire</MenuItem>
                  <MenuItem value={0}>Femme</MenuItem>
                  <MenuItem value={1}>Homme</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{display:"flex", alignItems:"center", gap:"10px", marginTop:"15px"}}>
              Âges&nbsp;:
              <FormControl size="small" sx={{height:"40px"}}>
                <Select value={ages} onChange={(e) => {setAges(e.target.value)}} >
                  <MenuItem value="random18-30">Aléatoire (entre 18 et 30 ans)</MenuItem>
                  <MenuItem value="random30-50">Aléatoire (entre 30 et 50 ans)</MenuItem>
                  <MenuItem value="random18-50">Aléatoire (entre 18 et 50 ans)</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{display:"flex", alignItems:"center", gap:"10px", marginTop:"15px"}}>
              Postes&nbsp;:
              <FormControl size="small" sx={{height:"40px"}}>
                <Select value={postes} onChange={(e) => {setPostes(e.target.value)}} >
                  <MenuItem value="IA">Générés par IA</MenuItem>
                  <MenuItem value="list">Liste de réponse(s)</MenuItem>
                </Select>
              </FormControl>
              {postes === "list" &&
                <Box>
                  {postesList.map((poste, index) => {
                    return (
                      <Box key={index} sx={{display:"flex", alignItems:"center", }}>
                        <TextField value={poste} size="small" sx={{marginTop:"5px"}} onChange={(e) => {
                          let newList = [...postesList]
                          newList[index] = e.target.value
                          setPostesList(newList)
                        }}/>

                        <XCircleIcon
                          color="black"
                          size={19}
                          style={{marginLeft:"15px", cursor: postesList.length !== 1 ? "pointer" : "default", opacity: postesList.length !== 1 ? 1 : 0.2}}
                          onClick={() => {
                            if (postesList.length !== 1) {
                              let newList = [...postesList]
                              newList.splice(index, 1)
                              setPostesList(newList)
                            }
                          }}
                        />
                        {index === postesList.length -1 &&
                          <PlusCircleIcon
                            color="black"
                            size={19}
                            style={{marginLeft:"15px", cursor:"pointer"}}
                            onClick={() => {
                              setPostesList([
                                ...postesList,
                                "poste"
                              ]);
                            }}
                          />
                        }
                      </Box>
                    )
                  })}
                </Box>
              }
            </Box>
          </Box>
        }
        {step === 2 &&
          <Box sx={{marginTop:"20px"}}>
            {groupState.icebreakerQuestions.secteurs === true &&
              <Box sx={{marginTop:"10px"}}>
                <Box sx={{fontWeight:"bold"}}>- {groupState.icebreakerQuestions.secteursQ}</Box>
                <Box>
                  {groupState.icebreakerQuestions.secteursReps.map((rep, index) => {
                    return (
                      <Box key={index} sx={{display:"flex", alignItems:"center"}}>
                        <Checkbox sx={{padding:"5px 9px"}} checked={secteurs.find((el) => el === index) !== undefined} onClick={() => {
                          let find = secteurs.find((el) => el === index)
                          if (find >= 0) {
                            setSecteurs(
                              secteurs.filter(el =>
                                el !== index
                              )
                            );
                          } else {
                            setSecteurs([
                              ...secteurs,
                              index
                            ]);
                          }
                        }}/>
                        {rep}
                      </Box>
                    )
                  })}
                </Box>
              </Box>
            }
            {groupState.icebreakerQuestions.annees === true &&
              <Box sx={{marginTop:"10px"}}>
                <Box sx={{fontWeight:"bold"}}>- {groupState.icebreakerQuestions.anneesQ}</Box>
                <Box>
                  {groupState.icebreakerQuestions.anneesReps.map((rep, index) => {
                    return (
                      <Box key={index} sx={{display:"flex", alignItems:"center"}}>
                        <Checkbox sx={{padding:"5px 9px"}} checked={annees.find((el) => el === index) !== undefined} onClick={() => {
                          let find = annees.find((el) => el === index)
                          if (find >= 0) {
                            setAnnees(
                              annees.filter(el =>
                                el !== index
                              )
                            );
                          } else {
                            setAnnees([
                              ...annees,
                              index
                            ]);
                          }
                        }}/>
                        {rep}
                      </Box>
                    )
                  })}
                </Box>
              </Box>
            }
            {groupState.icebreakerQuestions.diplome === true &&
              <Box sx={{marginTop:"10px"}}>
                <Box sx={{fontWeight:"bold"}}>- {groupState.icebreakerQuestions.diplomeQ}</Box>
                <Box>
                  {groupState.icebreakerQuestions.diplomeReps.map((rep, index) => {
                    return (
                      <Box key={index} sx={{display:"flex", alignItems:"center"}}>
                        <Checkbox sx={{padding:"5px 9px"}} checked={diplomes.find((el) => el === index) !== undefined} onClick={() => {
                          let find = diplomes.find((el) => el === index)
                          if (find >= 0) {
                            setDiplomes(
                              diplomes.filter(el =>
                                el !== index
                              )
                            );
                          } else {
                            setDiplomes([
                              ...diplomes,
                              index
                            ]);
                          }
                        }}/>
                        {rep}
                      </Box>
                    )
                  })}
                </Box>
              </Box>
            }
          </Box>
        }
        {step === 3 &&
          <>
            <Box sx={{marginTop:"10px"}}>
              {modulesChoose.length <= 1 ? (
                <font style={{fontWeight:"bold"}}>Module sélectionné&nbsp;:</font>
              ) : (
                <font style={{fontWeight:"bold"}}>Modules sélectionnés&nbsp;:</font>
              )}
              {modulesChoose.map((formation, index) => {
                let findDates = dates.find((el) => el.id === formation.id)
                return (
                  <Box key={index} sx={{padding:"5px 9px", marginBottom:"5px", display:"flex", flexDirection:"column", alignItems:"flex-start"}}>
                    <Box>
                      - {formation.name}&nbsp;: <font style={{fontWeight:"bold"}}> ({Moment(formation.openDate, "YYYY-MM-DD").format("DD/MM/YYYY")}) - ({Moment(formation.closeDate, "YYYY-MM-DD").format("DD/MM/YYYY")}) </font>
                    </Box>
                    <Box sx={{marginLeft:"20px", display:"flex", gap:"15px",}}>
                      <Box sx={{marginTop:"5px", display:"flex", gap:"5px", alignItems:"center"}}>
                        <font style={{fontWeight:"bold"}}>Date de début de la simulation&nbsp;:</font><br/>
                        <TextField
                          id="dateDebut"
                          size="small"
                          type="date"
                          value={Moment(findDates.openDate).format("YYYY-MM-DD")}
                          onChange={(e) => {
                            let newArr = [...dates]
                            let find = newArr.find(el => el.id === formation.id)
                            find.openDate = Moment(e.target.value, "YYYY-MM-DD")
                            setDates(newArr)
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            inputProps: {
                              min: formation.openDate,
                              max: formation.closeDate
                            }
                          }}
                        />
                      </Box>
                      <Box sx={{marginTop:"5px", display:"flex", gap:"5px", alignItems:"center"}}>
                        <font style={{fontWeight:"bold"}}>Date de fin de la simulation&nbsp;:</font><br/>
                        <TextField
                          id="dateFin"
                          size="small"
                          type="date"
                          value={Moment(findDates.closeDate).format("YYYY-MM-DD")}
                          onChange={(e) => {
                            let newArr = [...dates]
                            let find = newArr.find(el => el.id === formation.id)
                            find.closeDate = Moment(e.target.value, "YYYY-MM-DD")
                            setDates(newArr)
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            inputProps: {
                              min: formation.openDate,
                              max: formation.closeDate
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>
                )
              })}
            </Box>
            {dateIsValid === false &&
              <font style={{marginLeft:"10px", color:"red"}}>Les dates ne sont pas valides</font>
            }
          </>
        }
        {step === 4 &&
          <Box sx={{marginTop:"20px"}}>
            {modulesChoose.length <= 1 ? (
              <>
                Une simulation sera créée pour <span style={{fontWeight:"bold"}}>{nbrUsers} utilisateur(s)</span> sur le module suivant&nbsp;:
              </>
            ) : (
              <>
                Une simulation sera créée pour <span style={{fontWeight:"bold"}}>{nbrUsers} utilisateur(s)</span> sur les modules suivants&nbsp;:
              </>
            )}
            {modulesChoose.map((formation, index) => {
              let findDates = dates.find((el) => el.id === formation.id)
              return (
                <Box key={index} sx={{padding:"5px 9px", display:"flex", alignItems:"center", gap:"10px"}}>
                  - {formation.name} (<span style={{fontWeight:"bold"}}>{Moment(findDates.openDate, "YYYY-MM-DD").format("DD/MM/YYYY")}</span>) - (<span style={{fontWeight:"bold"}}>{Moment(findDates.closeDate, "YYYY-MM-DD").format("DD/MM/YYYY")}</span>)
                </Box>
              )
            })}
            <p style={{marginTop:"30px", fontWeight:"bold", color:"red"}}>
            Attention&nbsp;:<br/>
            La création de la simulation est une tâche très lourde pour le système.<br/>
            Il faut compter environ 1 seconde pour créer 4 à 5 simulations (1 simulation = 1 module pour 1 utilisateur), soit 240 à 300 simulations par minute.<br/>
            <br/>
            Merci de patienter jusqu'à la finalisation de l'opération sans recharger la page.
            </p>
          </Box>
        }
      </Box>
      <Box sx={{display:"flex", justifyContent:"center", marginTop:"40px"}}>
        {step == 0 &&
          <Button
            disabled={modulesChoose.length === 0}
            variant="contained"
            size="large"
            sx={{ minHeight:"35px !important" }}
            onClick={() => { setStep(1) }}
          >
            Suivant
          </Button>
        }
        {step == 1 &&
          <Box sx={{display:"flex", gap:"30px"}}>
            <Button
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { setStep(0) }}
            >
              Précédent
            </Button>
            <Button
              disabled={nbrUsers < 1}
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => {
                let icebreakerQuestions = groupState.icebreakerQuestions
                if (icebreakerQuestions.annees === false && icebreakerQuestions.diplome === false && icebreakerQuestions.secteurs === false) {
                  setStep(3) //direct vers choix des dates
                } else {
                  setStep(2)
                }
              }}
            >
              Suivant
            </Button>
          </Box>
        }
        {step == 2 &&
          <Box sx={{display:"flex", gap:"30px"}}>
            <Button
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { setStep(1) }}
            >
              Précédent
            </Button>
            <Button
              disabled={disableStep2}
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { setStep(3) }}
            >
              Suivant
            </Button>
          </Box>
        }
        {step == 3 &&
          <Box sx={{display:"flex", gap:"30px"}}>
            <Button
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => {
                let icebreakerQuestions = groupState.icebreakerQuestions
                if (icebreakerQuestions.annees === false && icebreakerQuestions.diplome === false && icebreakerQuestions.secteurs === false) {
                  setStep(1)
                } else {
                  setStep(2)
                }
              }}
            >
              Précédent
            </Button>
            <Button
              disabled={!dateIsValid}
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => { setStep(4) }}
            >
              Suivant
            </Button>
          </Box>
        }
        {step == 4 &&
          <Box sx={{display:"flex", gap:"30px", alignItems:"center"}}>
            <Button
              variant="contained"
              disabled={isCreating}
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => {
                setStep(3)
              }}
            >
              Précédent
            </Button>
            <Button
              disabled={isCreating}
              endIcon={isCreating && <img src={loadingGIF} style={{height:"25px"}}/>}
              variant="contained"
              size="large"
              sx={{ minHeight:"35px !important" }}
              onClick={() => {
                setIsCreating(true)
                setGlbPercent(0)
                let newDates = [...dates]
                newDates.forEach((d) => {
                  d.openDate = Moment(d.openDate).format("YYYY-MM-DD")
                  d.closeDate = Moment(d.closeDate).format("YYYY-MM-DD")
                })
                let values = {
                  uuid : glbUUID,
                  groupID : groupState.id,
                  groupCode : groupState.code,
                  groupIcebreakerID : groupState.icebreaker,
                  groupIcebreakerQuestions : groupState.icebreakerQuestions,
                  modulesChoose : modulesChoose,
                  nbrUsers : nbrUsers,
                  names : names,
                  emails : emails,
                  sexes : sexes,
                  ages : ages,
                  postes : postes,
                  postesList : postesList,
                  secteurs : secteurs,
                  annees : annees,
                  diplomes : diplomes,
                  dates : newDates,
                }
                APIS.createSimuForGroupe(values).then((result) => {
                  if (result?.isOk === true) {
                    setIsCreating(false)
                    onClose()
                    alert("Simulation créée")
                    reloadResults()
                  } else {
                    setIsCreating(false)
                    alert("Erreur")
                  }
                })
              }}
            >
              Créer
            </Button>
            {isCreating === true &&
              <Box sx={{width:"80px", fontWeight:"bold", fontSize:"20px", color:"red"}}>{glbPercent} %</Box>
            }
          </Box>
        }
      </Box>
    </Box>
  )
}

const SimulationModal = ({groupState, isOpen, onClose, reloadResults}) => {

  const [step, setStep] = useState(0)

  return (
    <Dialog
      fullWidth={true}
      maxWidth="xl"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx : {
          color:"black"
        }
      }}
    >
      <DialogContent reloadResults={reloadResults} groupState={groupState} step={step} setStep={setStep} onClose={onClose}/>
    </Dialog>
  )
}

export default SimulationModal
